import { render } from "./ModalEditGroup.vue?vue&type=template&id=b01693fe"
import script from "./ModalEditGroup.vue?vue&type=script&lang=js"
export * from "./ModalEditGroup.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__